import { createState } from '../../lib/create-state';

import { BingoJackpotWinnerMessage } from '../../types/bingo-events/in/backend/jackpot-winner-message';

export type JackpotWinnerState = BingoJackpotWinnerMessage[];

export const DEFAULT_JACKPOT_WINNER_STATE: JackpotWinnerState = [];

export const [jackpotWinner, resetJackpotWinner] = createState(
    DEFAULT_JACKPOT_WINNER_STATE
);
